import Main from './Main.vue'
import Arrematantes from './components/Arrematantes'
import VisualizarArrematante from './components/VisualizarArrematante'
import Arrematante from './components/Arrematante'
import Relatorios from './components/Relatorios'
import RelatorioBasico from './components/RelatorioBasico'
import PainelAprovacao from './components/PainelAprovacao'
import EstatisticasCadastro from './components/EstatisticaCadastro'

export default [{
  path: 'arrematantes',
  name: 'arrematantes',
  component: Main,
  children: [
    {path: '/', component: Arrematantes, name: 'arrematantes'},
    {path: 'aprovacao', component: PainelAprovacao, name: 'arrematantes.aprovacao'},
    {path: 'estatisticas', component: EstatisticasCadastro, name: 'arrematantes.estatisticas'},
    {path: ':id', component: VisualizarArrematante, name: 'arrematantes.visualizar'},
    {path: ':id/edit', component: Arrematante, name: 'arrematante.editar'},
    {
      path: 'relatorios',
      component: Relatorios,
      name: 'arrematantes.relatorios',
      children: [
        {path: 'basico', component: RelatorioBasico, name: 'arrematantes.relatorios.basico'}
      ]
    }
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/arematantes/routes.js